<template>
  <div v-if="can('update', 'payroll_info')">
    <b v-if="employeeState=='showing'"><p class="text-danger" v-if="edited">Los cambios no han sido guardados. <a href="#" @click.prevent="saveChanges">Guardar.</a></p></b>
    <b-button class="float-right" @click="resetNewCommissionLevels" v-if="edited == true" >Descartar cambios</b-button>
    <b-table responsive v-if="commissionLevels.length>0" :fields="commissionLevelFields" :items="commissionLevels" hover striped>
      <template slot="role" slot-scope="data">
        <span>{{ data.item.new ? getLabelFor(data.item.role) : data.item.role }}</span>
      </template>
      <template slot="actions" slot-scope="data">
        <b-button v-if="!(data.item.new)" size="sm" variant="danger" @click="deleteCommissionLevel({payroll_config_id: payrollConfig.id, index: data.index})">
          Eliminar
        </b-button>
      </template>
    </b-table>
    <b-button variant="success" v-if="state=='show'" @click="create">Agregar nivel de comisión</b-button>
    <div v-if="state=='creating'">
      <b-form-group horizontal label="Nivel">
        <b-form-select :options="commissionLevelOptions" :value="level" @input="updateCommissionLevel(['level', $event])"></b-form-select>
      </b-form-group>
      <b-form-group horizontal label="Role">
        <b-form-select :options="commissionRoleOptions" :value="role" @input="updateCommissionLevel(['role', $event])"></b-form-select>
      </b-form-group>
      <b-form-group horizontal label="Fecha a partir de la cual pertenece a este grupo">
        <b-form-input type="date" @input="updateCommissionLevel(['date', $event])" :value="date"></b-form-input>
      </b-form-group>
      <b-button variant="success" @click="addIfValid">Agregar</b-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { Validation } from '../../utils';
export default{
  props: {
    payrollConfig: {
      required: true,
      type: Object
    }
  },
  data (){
    return {
      commissionLevelFields: {
        level: {
          label: 'Nivel de comisión',
        },
        role: {
          label: 'Rol'
        },
        date: {
          label: 'A partir del',
        },
        actions: {
          label: ''
        }
      },
    }
  },
  methods: {
    can: (action, resource)=>{
      if(permissions===null) return false
      if(typeof(permissions[resource])==='undefined') return false
      return permissions[resource].includes(action)
    },
    ...mapActions(['resetNewCommissionLevels', 'saveChanges', 'deleteCommissionLevel']),
    ...mapMutations({
      updateCommissionLevel: 'updateNewCommissionLevelAttribute',
      create: 'creatingCommissionLevel'
    }),
    addIfValid (){
      var validation = this.valid()
      if(validation.valid)
        this.$store.dispatch('addCommissionLevel', {
          payroll_config_id: this.payrollConfig.id,
          level: this.level,
          date: this.date,
          role: this.role
        });
      else
        this.$store.dispatch('displayError',validation.messageBag);
    },
    valid (){
      var validator = new Validation();
      validator.rule(
        this.date!='', 'Debe haber una fecha')
      validator.rule(
        this.level!==null, 'Selecciona un nivel de comisión')
      return validator.validate()
    },
    getLabelFor(roleId) {
      for (var i = 0; i < this.commissionRoleOptions.length; i++) {
        if (roleId == this.commissionRoleOptions[i].value) {
          if (roleId) {
            return this.commissionRoleOptions[i].text;
          } else {
            return 'All';
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      edited: 'commissionLevelEdited'
    }),
    ...mapState({
      employeeState: state=>state.employeeManager.state,
      // commissionLevels: state=>state.employeeManager.employee.commissionLevels,
      state: state=>state.employeeManager.commissionLevelState,
      level: state=>state.employeeManager.newCommissionLevel.level,
      role: state=>state.employeeManager.newCommissionLevel.role,
      date: state=>state.employeeManager.newCommissionLevel.date,
      availableLevels: state=>state.employeeManager.commissionLevels,
      commissionRoleOptions: state => {
        var arr = [];
        for (var clr in state.employeeManager.commissionLevelRoles) {
          arr.push({
            value: clr,
            text: state.employeeManager.commissionLevelRoles[clr]
          });
        }
        
        arr.push({
          value: null,
          text: '--Todos los roles--'
        });

        return arr;
      }
    }),
    commissionLevelOptions(){
      return this.availableLevels.map(l=>{
        return {
          value: l.id, text: l.name
        }
      }).concat([{value: null, text:'--Seleccionar nivel de comisión--'}])
    },
    /*commissionRoleOptions(){
        return [
          {value: 5, text: 'Club Concierge'},
          {value: 3, text: 'Vacation Planer'},
          {value: 2, text: 'Financial Manager'},
          {value: 1, text: 'Junior'}
        ].concat([{value: null, text:'--Todos los roles--'}])
    },*/
    commissionLevels() {
      return this.payrollConfig.commissionLevels;
    }
  }

}
</script>
